<template>
  <LoginLayout>
    <div class="wrapper wrapper-full-page">
      <div class="container md-offset">
        <div class="md-layout text-center">
          <div
              class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100"
              style="margin-top: 40%"
          >
            <div class="md-card md-card-login md-theme-default">
              <form @submit.prevent="handleSubmit">
                <div
                    class="md-card-header md-card-header-green"
                >
                  <h4 class="title text-white">
                    InstantCare
                  </h4>
                </div>
                <div class="md-card-content">
                  <div>
                  <div
                      class="md-field md-form-group md-theme-default"
                  >
                    <i
                        class="md-icon md-icon-font md-theme-default"
                    >face</i
                    >
                    <label for="login-username"></label>
                    <input
                        id="login-username"
                        placeholder="Email"
                        type="text"
                        v-model="username"
                        name="username"
                        class="md-input"
                        :class="{
                                                'is-invalid':
                                                    submitted && !username
                                            }"
                    />
                    <div
                        v-show="submitted && !username"
                        class="invalid-feedback"
                    >
                      Username is required
                    </div>
                  </div>

                  <div
                      class="md-field md-form-group md-theme-default"
                  >
                    <i
                        class="md-icon md-icon-font md-theme-default"
                    >lock_outline</i
                    >
                    <label for="login-password"></label>
                    <input
                        id="login-password"
                        placeholder="Password"
                        type="password"
                        v-model="password"
                        name="password"
                        class="md-input"
                        :class="{
                                                'is-invalid':
                                                    submitted && !password
                                            }"
                    />
                    <div
                        v-show="submitted && !password"
                        class="invalid-feedback"
                    >
                      Password is required
                    </div>
                  </div>
                    <md-progress-spinner v-if="loggingIn" :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                </div>
                <div class="md-card-actions md-alignment-right">
                  <button
                      type="button"
                      class="md-button md-simple md-success md-lg md-theme-default"
                  >
                    <div class="md-ripple">
                      <div class="md-button-content">
                        <md-button
                            type="submit"
                            class="md-success md-block md-sm"
                        >Entrar
                        </md-button
                        >
                      </div>
                    </div>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </LoginLayout>
</template>

<script>
import LoginLayout from "./LoginLayout";
export default {
  components: {
    LoginLayout
  },
  data() {
    return {
      username: "",
      password: "",
      submitted: false,
    };
  },
  computed: {
    loggingIn() {
      return this.$store.state.authentication.status.loggingIn;
    }
  },
  created() {
    // reset login status
    this.$store.dispatch("authentication/logout");
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      const {username, password} = this;
      const {dispatch} = this.$store;
      if (username && password) {
        dispatch("authentication/login", {username, password});
      }
    }
  }
};
</script>

<style>
.title {
  color: white;
  font-weight: bold !important;
}
</style>
